export const AUTHENTICATION = "AUTH/AUTHENTICATION";
export const REGISTER = "AUTH/REGISTER";
export const LOGIN = "AUTH/LOGIN";
export const MY_PROFILE = "AUTH/MY_PROFILE";
export const ACTIVATE_ACCOUNT = "AUTH/ACTIVATE_ACCOUNT";
export const RESEND_ACTIVATION_LINK = "AUTH/RESEND_ACTIVATION_LINK";
export const FORGOT_PASSWORD = "AUTH/FORGOT_PASSWORD";
export const RESET_PASSWORD = "AUTH/RESET_PASSWORD";
export const CHANGE_PASSWORD = "AUTH/CHANGE_PASSWORD";
